import { render, staticRenderFns } from "./NewIndexing.vue?vue&type=template&id=61be3606&scoped=true&"
import script from "./NewIndexing.vue?vue&type=script&lang=js&"
export * from "./NewIndexing.vue?vue&type=script&lang=js&"
import style0 from "./NewIndexing.vue?vue&type=style&index=0&id=61be3606&scoped=true&lang=css&"
import style1 from "./NewIndexing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be3606",
  null
  
)

export default component.exports